import React from 'react';
import { B, D, Arr, Lbl, Lane } from '../shared/SvgHelpers';

export default function DiagramEskalation() {
  return (
    <div className="space-y-3" data-testid="diagram-eskalation">
      <h4 className="text-sm font-bold text-red-700">5. Eskalation &amp; Benachrichtigungen (6-stufig)</h4>
      <p className="text-xs text-slate-500">Zeitbasierte Eskalation ab 3 Tagen vor Fristablauf bis zum Vorgesetzten Level 2.</p>
      <svg viewBox="0 0 780 280" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        <Lane x={5} y={5} w={770} h={155} title="ESKALATION (6 zeitbasierte Stufen)" color="#dc2626" />
        <Lane x={5} y={170} w={770} h={105} title="BENACHRICHTIGUNGEN (ereignisbasiert) · Kanäle: In-App-Glocke, E-Mail" color="#d97706" />

        {/* Stufe 1: Deadline Warning (NEU) */}
        <B x={15} y={28} w={105} h={42} label={"Frist -3 Tage\nWarning"} color="#eab308" sub="deadline_warning" />
        <Arr x1={120} y1={49} x2={150} y2={49} />

        {/* Stufe 2: Overdue Notified (NEU) */}
        <B x={150} y={28} w={105} h={42} label={"Frist-Tag\nOverdue"} color="#f97316" sub="overdue_notified" />
        <Arr x1={255} y1={49} x2={285} y2={49} />

        {/* Stufe 3: Reminder 1 */}
        <B x={285} y={28} w={115} h={42} label={"Frist +N Tage\nReminder 1"} color="#d97706" sub="an Bearbeiter" />
        <Arr x1={400} y1={49} x2={430} y2={49} />

        {/* Stufe 4: Escalation L1 */}
        <B x={430} y={28} w={115} h={42} label={"Eskalation L1\n→ Supervisor 1"} color="#dc2626" sub="parallel" />
        <Arr x1={545} y1={49} x2={575} y2={49} />

        {/* Stufe 5: Reminder 2 */}
        <B x={575} y={28} w={105} h={42} label={"Frist +M Tage\nReminder 2"} color="#dc2626" sub="an Bearbeiter" />
        <Arr x1={680} y1={49} x2={710} y2={49} />

        {/* Stufe 6: Escalation L2 */}
        <B x={710} y={28} w={60} h={42} label={"L2\nChef"} color="#7f1d1d" sub="Supervisor 2" />

        {/* Zweite Reihe: Farb-Legende */}
        <rect x={15} y={95} width={760} height={42} rx={6} fill="#fff" stroke="#cbd5e1" />
        <text x={25} y={110} fontSize="9" fontWeight="700" fill="#334155">Farb-Legende:</text>
        <rect x={120} y={102} width={14} height={10} fill="#eab308" /><text x={138} y={111} fontSize="9" fill="#334155">Warning (vor Frist)</text>
        <rect x={260} y={102} width={14} height={10} fill="#f97316" /><text x={278} y={111} fontSize="9" fill="#334155">Overdue (am Frist-Tag)</text>
        <rect x={420} y={102} width={14} height={10} fill="#d97706" /><text x={438} y={111} fontSize="9" fill="#334155">Reminder (Bearbeiter)</text>
        <rect x={580} y={102} width={14} height={10} fill="#dc2626" /><text x={598} y={111} fontSize="9" fill="#334155">Escalation (Supervisor)</text>
        <text x={25} y={128} fontSize="9" fill="#64748b">Fristen via User-Settings: reminder1_days + reminder2_days · Standard: 0 + 3 Tage</text>

        {/* Ereignis-Benachrichtigungen */}
        {[
          { label: 'Reklamation\nangelegt', color: '#16a34a', x: 15 },
          { label: 'Status\ngeändert', color: '#2563eb', x: 140 },
          { label: 'Delegation\nerhalten', color: '#7c3aed', x: 265 },
          { label: 'Neue\nE-Mail', color: '#0891b2', x: 390 },
          { label: 'Deadline\n-Warning', color: '#eab308', x: 515 },
          { label: 'Eskalation\nausgelöst', color: '#dc2626', x: 640 },
        ].map((n, i) => (
          <g key={i}>
            <B x={n.x} y={195} w={115} h={32} label={n.label} color={n.color} />
          </g>
        ))}

        <rect x={15} y={238} width={240} height={22} rx={11} fill="#d97706" opacity={0.08} stroke="#d97706" strokeWidth={0.8} />
        <text x={135} y={252} textAnchor="middle" fontSize="10" fontWeight="600" fill="#d97706">In-App-Glocke (alle Events)</text>
        <rect x={275} y={238} width={240} height={22} rx={11} fill="#2563eb" opacity={0.08} stroke="#2563eb" strokeWidth={0.8} />
        <text x={395} y={252} textAnchor="middle" fontSize="10" fontWeight="600" fill="#2563eb">E-Mail SMTP (Brevo + IONOS)</text>
        <rect x={535} y={238} width={220} height={22} rx={11} fill="#dc2626" opacity={0.08} stroke="#dc2626" strokeWidth={0.8} />
        <text x={645} y={252} textAnchor="middle" fontSize="10" fontWeight="600" fill="#dc2626">Eskalations-E-Mail (L1 + L2)</text>
      </svg>
    </div>
  );
}
